import OptimizedImage from '@/shared/ui/OptimizedImage/OptimizedImage';
import { isValidUrl } from '../../lib';
import type { InfoCardProps } from './InfoCard.types';

export const InfoCard = ({
  image,
  imgAlt,
  children,
  style,
  link,
  'data-testid': dataTestId,
}: InfoCardProps) => {
  const urlIsValid = isValidUrl(link);
  const content = (
    <div
      className={`p-4 bg-[#FCFCFC] dark:bg-card rounded-lg border border-border-light flex flex-row gap-2.5 items-start ${style}`}
      data-testid={dataTestId}
    >
      {image && <OptimizedImage src={image} alt={imgAlt || ''} />}
      <div className="flex flex-col w-full">{children}</div>
    </div>
  );

  return urlIsValid ? (
    <a href={link} target="_blank" rel="noopener noreferrer">
      {content}
    </a>
  ) : (
    content
  );
};
